<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        body: [
          'A shared ID happens when two different people are assigned the same identifier.'
          + 'If an identifier is shared, one of the records should be split to a new master record and identifier.'
          + 'History records will need to be assigned to the corresponding master record',
          'To split a Person Record, move at least one Person History Record from the History Records section in the ID TO BE RETAINED column to the ID TO BE SPLIT (NEW ID TO BE CREATED) column.'
          + 'Move additional records as needed between the two columns.'
          + 'Once the information is correct for the split, click the “Submit” button.',
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
